export default __webpack_public_path__ + "static/media/Preloader_8.2e41b447.gif";